<ion-content class="ion-padding unsupported-browser-content">
  <div class="unsupported-browser-box">
    <ion-icon name="musical-notes-outline" aria-hidden="true" class="unsupported-browser-icon"></ion-icon>
    <h2>{{ 'ui.unsupported.browser.component.text.navegador_no_compatible' | translate }}</h2>
    <p>{{ 'ui.unsupported.browser.component.text.este_navegador_no_puede_conectarse_al_teclado' | translate }}</p>
    <p>{{ 'ui.unsupported.browser.component.text.usa_chrome_o_edge_para_continuar' | translate }}</p>
    <ion-button href="https://www.google.com/chrome/" target="_blank" rel="noopener noreferrer">
      <ion-icon slot="start" name="logo-chrome" aria-hidden="true"></ion-icon>
      {{ 'ui.unsupported.browser.component.text.descargar_google_chrome' | translate }}
    </ion-button>
    <ion-button fill="outline" (click)="retry()">
      {{ 'ui.unsupported.browser.component.text.reintentar' | translate }}
    </ion-button>
  </div>
</ion-content>
